import * as yup from 'yup';

export const sellerUploadFileModalSchema = yup.object({
  storeId: yup.string().required('Selecionar uma loja é obrigatório.'),
});
